import { useEffect, useCallback } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCheck, faInfo, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';

// Services

import {
    insertarClienteEnBackoffice,
    subirArchivosDeConstanciaDelCliente
} from '../../../../store/clients/clients.actions';

// Components

import SectionHeading from '../../../UI/SectionHeading/SectionHeading';
import Button from '../../../UI/Button/Button';

// Constants

import { DUE_DILIGENCE_SPECIAL_CATEGORIES } from '../../../../config/constants';

// Styles

import './Styles.scss';

export default function RegisterClient({ formik, setSendData }) {

    // Backoffice
    const insertClientInBackOffice = useSelector((state) => state.clients.insertClientInBackOffice);
    const uploadClientFilesToBackOffice = useSelector((state) => state.clients.uploadClientFilesToBackOffice);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        handleUploadClientConstancyFiles(formik.values);
    }, []);

    // Handle Upload Client Constancy Files

    const handleUploadClientConstancyFiles = useCallback((values) => {
        const files = values?.recaudos;
        const data = new FormData();

        data.append("email", values?.cliente?.mail);
        data.append("documentoIdentidad", files?.documentoIdentidad);
        data.append("documentoPasaporte", files?.documentoPasaporte);
        data.append("constanciaResidenciaRif", files?.constanciaResidenciaRif);
        data.append("constanciaEmpleo", files?.constanciaEmpleo);
        data.append("constanciaIngreso", files?.constanciaIngreso);
        data.append('constanciaOrdenTribunal', files?.constanciaOrdenTribunal);
        data.append('constanciaAutorizacionOperarMercado', files?.constanciaAutorizacionOperarMercado);
        data.append('constanciaCarnetLaboral', files?.constanciaCarnetLaboral);
        data.append('constanciaCedulaRepresentanteLegal', files?.constanciaCedulaRepresentanteLegal);
        data.append('constanciaDesignacionLegalComoRepresentante', files?.constanciaDesignacionLegalComoRepresentante);
        data.append('constanciaComplementoFatca', files?.constanciaComplementoFatca);
        data.append('constanciaDeclaracionJuradaDeIngresos', files?.constanciaDeclaracionJuradaDeIngresos);

        dispatch(subirArchivosDeConstanciaDelCliente(data));
    }, []);


    // Insert client in backoffice afteruploading the constancy files

    useEffect(() => {
        if (uploadClientFilesToBackOffice?.success) {
            handleInsertClientInBackoffice(formik.values)
        }
    }, [uploadClientFilesToBackOffice?.success]);


    // Handle Insert Client In Backoffice

    const handleInsertClientInBackoffice = useCallback((values) => {
        const currentDate = moment().format();

        const data = {
            full_name: values?.cliente?.nombre + ' ' + values?.cliente?.primerApellido + ' ' + values?.cliente?.segundoApellido,
            email: values?.cliente?.mail,
            document: values?.cliente?.tipoDocumento !== 'P' ? values?.cliente?.tipoDocumento + values?.cliente?.cedulaRif : values?.cliente?.tipoDocumento + values?.cliente?.pasaporte,
            type: 'nuevo',
            date: currentDate,
            specialCategory: values?.cliente?.categoriaEspecial,
            specialCategoryAnswer: DUE_DILIGENCE_SPECIAL_CATEGORIES?.includes(values?.cliente?.categoriaEspecial) ? values?.dueDiligence : null
        }

        dispatch(insertarClienteEnBackoffice(data));
    }, []);


    // Upload client constancy files after insterting to backoffice

    useEffect(() => {
        if (!insertClientInBackOffice?.success) return;

        const timeout = setTimeout(() => {
            navigate(`/success`, { state: { formCompleted: true }, replace: true });
        }, 3000);

        return () => clearTimeout(timeout);
    }, [insertClientInBackOffice?.success, navigate]);


    return (
        <div>
            <SectionHeading text={'Enviando datos...'} isSubHeading />

            <ServiceStatus
                label={'Subiendo recaudos de cliente...'}
                loading={uploadClientFilesToBackOffice?.isLoading}
                success={uploadClientFilesToBackOffice?.success}
                error={uploadClientFilesToBackOffice?.error}
                action={() => handleUploadClientConstancyFiles(formik.values)}
            />

            <ServiceStatus
                label={'Guardando datos de cliente...'}
                loading={insertClientInBackOffice?.isLoading}
                success={insertClientInBackOffice?.success}
                error={insertClientInBackOffice?.error}
                action={() => handleInsertClientInBackoffice(formik.values)}
            />

            <div className='form-actions'>

                <Button
                    action={() => setSendData(false)}
                    label={'Regresar'}
                    secondaryStyle={true}
                    disabled={insertClientInBackOffice?.isLoading || uploadClientFilesToBackOffice?.isLoading}
                />

            </div>

        </div>
    )

}

const ServiceStatus = ({ label, loading, success, error, action }) => {
    return (
        <div className={`serviceStatus  ${loading ? "serviceStatusLoading" : ""} ${error ? "serviceStatusError " : ""} ${success ? "serviceStatusSuccess" : ""}`}>
            <div className={`serviceIconContainer ${loading ? "serviceIconContainerLoading" : ""} ${error ? "serviceIconContainerError " : ""} ${success ? "serviceIconContainerSuccess" : ""}`}>
                {loading &&
                    <FontAwesomeIcon className='serviceStatusIcon serviceStatusIconLoading' icon={faSpinner} spin />}

                {success &&
                    <FontAwesomeIcon className='serviceStatusIcon serviceStatusIconSuccess' icon={faCheck} />}

                {error &&
                    <FontAwesomeIcon className='serviceStatusIcon serviceStatusIconError' icon={faInfo} />}

                {!loading && !success && !error &&
                    <FontAwesomeIcon className='serviceStatusIcon' icon={faClock} />}
            </div>
            <p>
                <strong>{label}</strong>
                {error && <span className='serviceStatusErrorMessage'>{error}</span>}
            </p>

            {error &&
                <button className='serviceStatusButton' onClick={() => action()} title={'Reintentar'}>
                    <FontAwesomeIcon className='serviceStatusButtonIcon' icon={faRotateRight} />
                </button>}
        </div>
    );
};
